import { StyleSheet } from 'aphrodite'
import { snackbar } from 'consts'

const styles = StyleSheet.create({
  wrapper: {
    position: 'fixed',
    top: 0,
    left: '50%',
    marginLeft: -175,
    width: 350,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    zIndex: 10000
  },
  snackbar: {
    display: 'inline-flex',
    width: 'inherit',
    height: 0,
    minHeight: 0,
    padding: '0 24px',
    marginBottom: 1,
    fontSize: 13,
    overflow: 'hidden',
    visibility: 'hidden',
    alignItems: 'center',
    transition: `all ${snackbar.animationTime}ms cubic-bezier(0.23, 1, 0.32, 1) 0ms`,
    transform: 'translate3d(0px, -100px, 0px)'
  },
  text: {
    flexGrow: 1
  },
  visible: {
    minHeight: 48,
    visibility: 'visible',
    transform: 'translate3d(0px, 0px, 0px)'
  },
  normal: {
    color: '#fff',
    backgroundColor: '#009ee3'
  },
  error: {
    color: '#FFF',
    backgroundColor: '#d9534f'
  },
  warning: {
    color: 'rgba(0,0,0,0.75)',
    backgroundColor: '#f2d465'
  },
  success: {
    color: 'rgba(0,0,0,0.75)',
    backgroundColor: '#a0f495'
  },
  action: {
    display: 'inline-block',
    flex: 0,
    textAlign: 'right',
    fontWeight: 'bold',
    cursor: 'pointer',
    textTransform: 'uppercase'
  },
  light: {
    color: '#545a5f',
    background: '#fff'
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/Common/Snackbar/styles.js